import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Truncate from '../../core/Truncate';
import Button from '../../core/Buttons';
import OptionsNews from '../../core/OptionsNews';
import { SocialMedia } from '../../core/SocialMedia';
import DateFormat from '../../core/DateFormat';
import Credit from '../../core/Credit';
import TagCategory from '../../core/TagCategory';
import Headline from '../../core/Headline';

// Capa para el contenedor de la noticia
export const StyledBoxNewsTab = styled.div`
  background-color: ${props => props.theme.colors.light};

  /* clearfix */
  &:after {
    content: '';
    height: 0;
    display: block;
    width: 100%;
    clear: both;
  }

  ${props =>
    props.orientation === 'horizontal' &&
    css`
      margin-bottom: 1rem;
    `};
`;

// Capa para los textos de toda la noticia
export const StyledBoxNewText = styled.article`
  position: relative;
  padding: ${rem('15px')};
  overflow: hidden;
  height: ${props => (props.orientation === 'vertical' ? '100%' : 'auto')};
  ${props =>
    props.share &&
    css`
      min-height: ${rem('300px')};
    `};
  ${props =>
    props.orientation === 'horizontal' &&
    css`
      border-bottom: 1rem solid ${props.theme.colors.grayLighter};
    `};

  ${mediaqueries.greaterThan('mobile')`
    padding: ${rem('30px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
  ${props =>
    props.orientation === 'vertical' &&
    css`
      min-height: 21.375rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    `};
  `};
`;

export const LinkHeader = styled(Link)`
  font-family: inherit;
  color: inherit;
  :hover {
    color: ${props => props.theme.colors.primary};
  }
`;

// Capa para autor e iconos de opciones
export const StyledBoxOptions = styled.div`
  margin: 1.5rem 0 0;
  position: relative;
  width: 100%;

  /* clearfix */
  :after {
    content: '';
    height: 0;
    display: block;
    width: 100%;
    clear: both;
  }
`;
// Capa para las opciones de iconos
export const StyledOptionsNews = styled(OptionsNews)`
  float: right;
  margin-top: ${rem('10px')};
`;
// Capa para las opciones de Avatar
export const StyledCredit = styled(Credit)`
  float: left;
`;
// Tag de Categoria
export const StyledTagCategory = styled(TagCategory)`
  margin: 0 0 ${rem('5px')} 0;
  ${mediaqueries.greaterThan('mobile')`
    margin: 0 0 1rem 0;
  `};
`;
// Texto de Publicado de la noticia
export const StyledDateNews = styled.p`
  font-size: ${props => props.theme.fontSize.xsmall};
  font-family: ${props => props.theme.fonts.medium};
  margin: 0 0 ${rem('10px')};
  text-decoration: underline;

  ${mediaqueries.greaterThan('mobile')`
    margin: 0 0 ${rem('20px')};
    font-size: ${props => props.theme.fontSize.small};
  `};
`;

export const OverwriteDateFormat = styled(DateFormat)`
  font-family: inherit;
  font-size: inherit;
`;

// Texto + leer más
export const StyleLinkRead = styled(Link)`
  display: none;
  color: ${props => props.theme.colors.primary};
  font-size: ${props => props.theme.fontSize.small};
  font-family: ${props => props.theme.fonts.bold};
  margin: 0.9375rem 0 0;

  &:hover {
    raycolor: ${props => props.theme.colors.g};
  }

  ${mediaqueries.greaterThan('tablet')`
    display: inline;
  `};
`;
// Texto de Publicado de la noticia
export const StyledMultimedia = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    ${props =>
      props.orientation === 'vertical' &&
      css`
        float: left;
        width: ${rem('608px')};
      `};
  `};
`;

/**
 *  ARTICLE
 */
// Capa contenedora principal
export const StyledContainerPrincipal = styled.div`
  padding-top: ${rem('29px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: auto;
    max-width: ${rem('1016px')};
    padding: ${rem('55px')} 0 ${rem('70px')} 0;
  `};
`;

export const StyledHeader = styled.header`
  margin-bottom: 1rem;
  flex-basis: 100%;
`;

// Capa contenedora columnas
export const StyledContainerColumn = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    flex-wrap: wrap;
  `};

  > ${StyledHeader} {
    padding: 0 1rem;

    ${mediaqueries.greaterThan('tablet')`
      padding: 0 1.5rem;
    `};

    ${mediaqueries.greaterThan('desktop')`
      padding: 0;
    `};
  }
`;

// Columna 1
export const StyledArticleColumn1 = styled.article`
  padding: 0 ${rem('24px')} ${rem('65px')} ${rem('24px')};
  ${mediaqueries.lessThan('mobile')`
    padding: 0 ${rem('16px')} ${rem('65px')} ${rem('16px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin-right: ${rem('60px')};
    padding: 0;
    flex-basis: calc(100% - (${rem('60px')} + ${rem('308px')}));
  `};
  & img {
    max-width: 100%;
  }
  a {
    color: ${props => props.theme.colors.primary} !important;
  }
`;

// Columna 2
export const StyledArticleColumn2 = styled.aside`
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  display: flex;
  flex-direction: column;
  padding-bottom: ${rem('32px')};

  ${mediaqueries.greaterThan('desktop')`
    background-color:inherit;
    flex-basis: ${rem('308px')};
  `};
`;

// Tag de Categoria en artículo
export const StyledTagCategoryArticle = styled(TagCategory)`
  margin-bottom: ${rem('16px')};
  margin-right: ${rem('25px')};

  &:last-child {
    margin-right: 0;
  }
`;

// Capa para las opciones de iconos
export const StyledOptionsSocialMedia = styled(SocialMedia)`
  border: ${rem('4px')} solid ${props => props.theme.colors.dark};
  height: ${rem('50px')};
  max-width: ${rem('220px')};
  padding: 0 3%;

  &:after {
    background-color: ${props => props.theme.colors.grayLightest};
    content: '';
    height: ${rem('22px')};
    position: absolute;
    right: ${rem('-4px')};
    transform: translate(0, -50%);
    top: 50%;
    width: ${rem('4px')};
  }

  ${mediaqueries.greaterThan('320px')`
    max-width: ${rem('327px')};
    padding: 0 ${rem('33px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    height:${rem('83px')};
    padding: 0 ${rem('45px')};

    &:after {
      background-color: ${props => props.theme.colors.light};
      height: ${rem('34px')};
    }

  `};
`;

// Style Image
export const StyledImage = styled.img`
  height: auto;
  width: 100%;
`;

// Style FigureFullWidht
export const StyledFigureFull = styled.figure`
  width: 60%;
  margin-left: 20%;
  object-fit: cover;
  display: block;
  ${mediaqueries.lessThan('mobile')`
    width: 100%;
    margin-left: 0%;
    padding:${rem('20px')} ${rem('15px')} 0 ${rem('17px')};
  `};
`;

export const Strapline = styled(Truncate)`
  font-size: ${rem('16px')};
  line-height: ${rem('22px')};
`;

export const SubtitleHeader = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
`;

export const StyledHeadline = styled(Headline)`
  font-size: ${rem('18px')};
  line-height: ${rem('22px')};
  margin-bottom: ${rem('10px')};
  ${mediaqueries.greaterThan('mobile')`
    font-size: ${rem('20px')};
    line-height: ${rem('24px')};
  `};
`;

export const StyledTruncateTitle = styled(Truncate)`
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
`;

export const StyledNewsMoreAdvice = styled.div`
  text-align: center;
  margin: ${rem('7px')};
  font-size: ${rem('14px')};
  line-height: 1.2;
  ${mediaqueries.greaterThan('desktop')`
    margin: 0 0 ${rem('15px')} 0;
  `};
`;

export const StyledNewsMoreAdviceButton = styled(Button)`
  border-color: ${props => props.theme.colors.dark};
  color: ${props => props.theme.colors.dark};
  margin: 0 ${rem('10px')};
  &:hover {
    border-color: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.primary};
  }
`;

export const StyledNewsWidget = styled.div`
  width: auto;

  .appNotifications-iconNot {
    display: none;
  }
`;

export const StyledButtonUpdate = styled.div`
  margin: 0rem auto 1.5rem;
  border-radius: 3px;
  padding: 10px;
  max-width: ${rem('1232px')};
  padding-top: ${rem('30px')};
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.light};
  text-align: center;
  cursor: pointer;
  ${mediaqueries.lessThan('mobile')`
    padding-top: ${rem('8px')};
    margin-top: ${rem('32px')};
  `}
  ${mediaqueries.greaterThan('mobile')`
    padding-top: ${rem('8px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-top: ${rem('10px')};
    margin-bottom: ${rem('60px')};
  `};
`;

export const StyledSendMsg = styled.p`
  text-align: center;
  font-family: ${props => props.theme.fonts.bold};
`;
